// extracted by mini-css-extract-plugin
export default {"container":"InlineAutocomplete-module__container--lzMAk","fullWidth":"InlineAutocomplete-module__fullWidth--xhTmc"};